export const SECTION_EXTENSION_CONTENT = [
	{
		type: 'extensionFrame',
		content: [
			{
				type: 'heading',
				attrs: { level: 1 },
				content: [{ type: 'text', text: 'Give your section a title' }],
			},
			{
				type: 'paragraph',
				content: [
					{
						type: 'text',
						text: 'Organize elements into sections with customizable backgrounds.',
					},
				],
			},
		],
	},
];

export const getSectionExtensionContents = () => SECTION_EXTENSION_CONTENT;
